import { putData } from "../backend";
import { Team, TeamUser } from "../interfaces";
import { BLOCK_ICON_MAP } from "../utils";
import useUser from "../hooks/useUser";
import Avatar from "./Avatar";
import moment from "moment";
import SettingsTeamUserRole from "./SettingsTeamUserRole";
import { useState } from "react";
import SettingsTeamUserModalAccess from "./SettingsTeamUserModalAccess";
import { useModal } from "../contexts";

interface Props {
  user: TeamUser;
  onRemove?: () => void;
}

function SettingsTeamUser(props: Props) {
  const teamUser = props.user;
  const { refreshUser } = useUser();

  const [isUpdating, setIsUpdating] = useState(false);

  const { openModal } = useModal();

  function handleRemoveUser() {
    setIsUpdating(true);
    putData(`/auth/team/remove/`, { user: teamUser.id })
      .then((team: Team) => {
        refreshUser((user: any) => ({ ...user, team }));
      })
      .catch(console.error)
      .finally(() => setIsUpdating(false));
  }

  function handleChangeUserRole(role: string) {
    setIsUpdating(true);
    putData(`/auth/team/change-user-role/`, { user: teamUser.id, role })
      .then((team: Team) => {
        refreshUser((user: any) => ({ ...user, team }));
        openModal(<SettingsTeamUserModalAccess teamUser={teamUser} />);
      })
      .catch(console.error)
      .finally(() => setIsUpdating(false));
  }

  return (
    <tr>
      <td className="w-auto">
        <div className="flex items-center gap-2 text-sm my-2">
          <Avatar url={teamUser.avatar} className="h-10 w-10 flex-shrink-0" />
          <div className="flex flex-col">
            <div className="font-gilroy font-bold">{teamUser.fullName}</div>
            <div className="text-gray-400">{teamUser.email}</div>
          </div>
        </div>
      </td>
      <td className="w-[200px]">
        <div className="w-40">
          <SettingsTeamUserRole teamUser={teamUser} role={teamUser.teamRole} onSelectRole={handleChangeUserRole} onRemove={handleRemoveUser} isUpdating={isUpdating} />
        </div>
      </td>
      <td className="text-gray-400 text-sm text-left w-[100px]">
        {teamUser.usage}
      </td>
      <td className="w-[200px]">
        <div className="flex items-center gap-1 h-full">
          {teamUser.linkedAccounts.map(icon => <img key={icon} src={BLOCK_ICON_MAP[icon]} className="w-4 h-4 flex-shrink-0" alt="Linked account icon" />)}
        </div>
      </td>
      <td className="text-gray-400 text-sm text-left w-[200px] pr-[20px]">
        {moment(teamUser.dateLastLogin).format("MMM D, h:mma")}
      </td>
    </tr>
  );
}

export default SettingsTeamUser;
